module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av548-807d3e6c8625aa781dc0e3ab99bfe6d8.jpg";